/**
 * Транзиентные сообщения SignalR, которые не являются ошибками приложения (KAN-600).
 *
 * Обрыв рукопожатия, отмена старта, 502 от шлюза в момент перезапуска бэкенда —
 * штатная жизнь соединения: клиент переподключится сам. Живой пример из
 * GlitchTip (FRONTEND-2I, 20.08.2026, `/profile`): negotiate обоих хабов прошёл
 * с 200, а рукопожатие оборвалось следом, и «Handshake was canceled» всплыл
 * из недр клиента — не через `start().catch()`, а из обработчика входящего
 * сообщения при авто-реконнекте.
 */
const TRANSIENT_PATTERNS = [
  "before stop() was called",
  "stopped during negotiation",
  "handshake was canceled",
  "handshake error",
  "the connection was stopped",
  "server timeout elapsed without receiving a message",
] as const;

/** Шлюз ответил ошибкой, пока бэкенд перезапускался — соединение поднимется само. */
const TRANSIENT_STATUS = /\b(404|502|503|504)\b/;

export function isSignalRTransientNoise(error: unknown): boolean {
  const message =
    error instanceof Error ? error.message : typeof error === "string" ? error : "";
  if (!message) return false;

  const lower = message.toLowerCase();
  return (
    TRANSIENT_PATTERNS.some((pattern) => lower.includes(pattern)) ||
    TRANSIENT_STATUS.test(message)
  );
}
